import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Scheme } from '../types/scheme';

export interface IStyleService {
  theme$: BehaviorSubject<Scheme>;
}

export const STYLE_SERVICE = new InjectionToken<IStyleService>('I Style Service');
